import mustache from "mustache";
import { IConnectRender } from "../../definitions/IConnectRender";
import { BaseCreateRender } from "../BaseCreateRender";
import template from "./fsModalTemplate.html";

mustache.parse(template);

/** Base de modales a pantalla completa (auto-montados sobre `body`, extiende
 *  `BaseCreateRender`): barra superior (atrás + título + subtítulo) y un cuerpo
 *  full-screen donde se monta un `IConnectRender` (p. ej. un mapa). El botón
 *  "atrás" cierra el modal. La subclase define `elementId`, `title` y el
 *  contenido (`getContent`). */
export abstract class BaseFullScreenModalRender extends BaseCreateRender {
  /** Título de la barra superior. */
  protected abstract get title(): string;

  /** Subtítulo opcional de la barra. */
  protected get subtitle(): string | undefined {
    return undefined;
  }

  /** Contenido del cuerpo (se monta en el área full-screen). */
  protected abstract getContent(): IConnectRender;

  /** HTML del modal: overlay full-screen + chrome + contenido embebido. */
  protected getHtml(): string {
    this._content = this.getContent();
    return mustache.render(template, {
      title: this.title,
      subtitle: this.subtitle,
      content: this._content.render(),
    });
  }

  /** Conecta el contenido, cablea el botón "atrás" y anima la apertura. */
  protected afterInit(element: HTMLDivElement): void {
    this._content?.connect();
    this._overlay = element.querySelector<HTMLDivElement>(".sx-modal-overlay");
    this._closeBtn = element.querySelector<HTMLElement>('[data-act="close"]');
    this._closeBtn?.addEventListener("click", this._onClose);
    requestAnimationFrame(() =>
      this._overlay?.classList.add("sx-modal-overlay--open"),
    );
  }

  /** Libera el botón y dispone el contenido. */
  protected beforeDispose(_element: HTMLDivElement): void {
    this._closeBtn?.removeEventListener("click", this._onClose);
    this._content?.dispose();
  }

  private _content: IConnectRender | null = null;
  private _overlay: HTMLDivElement | null = null;
  private _closeBtn: HTMLElement | null = null;

  private _onClose = (): void => this.dispose();
}
